export const navHeight = 40;

export const mainWidth = '65%';

export const primaryColor = '#D65456';

export const primaryFont = 'Open Sans, Georgia, serif';